<div class="card" *ngIf="!isMockUp; else mockupCard">
  <div class="card__side_ribbon" [ngClass]="card.DateBadgeColor"></div>

  <div class="card__body">
    <div class="card__title q-c-main q-bold" title="{{getCardInformation(card)}}"><i *ngIf="card.Priorite === '10'" class="fas fa-exclamation q-c-main"></i>{{card.Client}}  </div>

    <div class="card__date mb-1"> {{card.Date|qDateShort}} <span *ngIf="card.IsCloture" class="float-right q-text-s q-bold q-c-secondary">Cloturé</span></div>
    <div class="card__text card__text--title mb-1">{{card.Title}}</div>
    <div class="card__text  mt-1 card__text--lean card__text--overflow">{{card.Info}}</div>
  </div>
  <div class="card__footer">
    <div class="footer__price">
      <img [src]="card.CollaboAvatarUrl" loading="lazy" title="{{card.CollaboName}}" />
      <div *ngIf="card.NumDevis" title="Devis N°{{card.NumDevis}}" class="card__text ml-2">N°{{card.NumDevis}}</div>
    </div>
    <div class="footer__picto">
      <!--<div class="font-weight-bold" [ngClass]="card.StatusBadgeColor"><ng-container *ngIf="card.Status; else prix">{{card.Status}}</ng-container></div>
  <ng-template #prix>
    <ng-container *ngIf="!isPonderation; else prixPonderation">{{card.Price|money}}</ng-container>
  </ng-template>
  <ng-template #prixPonderation>
    {{card.PricePonderation|money}}
  </ng-template>-->



      <div class="font-weight-bold" [ngClass]="card.StatusBadgeColor"> <ng-container *ngIf="!isPonderation; else prixPonderation">{{card.Price|money}}</ng-container></div>
      <ng-template #prixPonderation>
        {{card.PricePonderation|money}}
      </ng-template>





      <div title="{{card.HistoNumberOfDaysInfo}}"><i class="far fa-calendar-alt" title="{{card.HistoNumberOfDaysInfo}}"></i><span class="card__text card__text--lean">{{card.HistoNumberOfDays}} j.</span></div>
      <div title="{{card.HistoLastInfo}} apprenant.e.s"><i class="fas fa-comment-alt" title="{{card.HistoLastInfo}}"></i><span class="card__text card__text--lean">{{card.HistoNb}}</span></div>
    </div>
  </div>
</div>






<ng-template #mockupCard>
  <div class="card mockup">
    <div class="card__body">
      <div class="card__title q-c-main q-bold row mx-0">
        <div class="placeholder col-3"></div>
      </div>
      <div class="card__text mb-1 ellipsis row mx-0">
        <div class="placeholder col-2"></div>
      </div>
      <div class="card__text mb-1 pipeCard-desc row mx-0">
        <div class="placeholder col-1"></div>
        <div class="placeholder col-1"></div>
        <div class="placeholder col-4"></div>
        <div class="placeholder col-2"></div>
      </div>
    </div>
    <div class="card__footer">
      <div class="footer__price">
        <div class="pipeCard-footer-right-photo">
          <img class="placeholder" />
        </div>
        <div class="placeholder col-2"></div>
      </div>
      <div class="footer__picto">
        <div class="placeholder col-2"></div>
        <div class="placeholder col-2"></div>
        <div class="placeholder col-2"></div>
      </div>
    </div>
  </div>
</ng-template>






